// list1 is array of item objects
// list2 is array of item values
// if list1 contains an item partNumber that exists in list2
// remove item from list1
// format list2 object structure
// combine both lists and return
export default (function (list1, list2) {
  return list1.filter(function (item) {
    return !list2.includes(item.partNumber);
  }).concat(list2.map(function (item) {
    return {
      partNumber: item
    };
  }));
});